export default __webpack_public_path__ + "static/media/bg-login.97e7184a.jpg";